module.exports = __webpack_public_path__ + "static/7i-9e9a574493d4cd2fa62380f376461941.woff";